import React, { Component } from 'react';
import { connect } from 'react-redux';
import IconBoxes from '../../../../../components/iconBoxes.js';
import Panel from '../../../../../components/panel.js';
import SimpleAreaChart from '../../../../../charts/simpleAreaChart.js';
import SimpleLineChart from '../../../../../charts/simpleLineChart.js';
import TableComponent from '../../../../../containers/table.js';

class SupadminDashBoard extends Component {
  // constructor(props) {
  //   super(props);
  // }

  render() {
    return (
      <div>
        <IconBoxes/>
        {/*<div className="row">
          <div className="col-md-6">
            <Panel
              title="Total Earns"
              righticon={true}
            >
              <SimpleAreaChart/>
            </Panel>
          </div>

          <div className="col-md-6">
            <Panel
              title="Total Sales"
              righticon={true}
            >
              <SimpleLineChart/>
            </Panel>
          </div>
        </div>

         <Panel
          title="User Table"
          righticon={true}
        >
          <TableComponent/>
        </Panel> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loginUserInfo: state.superadminLogin.loginUserInfo,
  };
};

export default connect(mapStateToProps, null)(SupadminDashBoard);





// WEBPACK FOOTER //
// ./src/modules/Superadmin/components/dashboard/components/superadmin_dashboard.js